import { motion } from "framer-motion";
import { useEffect } from "react";
import { useCart } from "../context/CartContext";
import toast from "react-hot-toast";

export default function ProductModal({ item, close }) {
  const { addToCart } = useCart();

  // Disable background scroll
  useEffect(() => {
    document.body.style.overflow = item ? "hidden" : "auto";
    return () => (document.body.style.overflow = "auto");
  }, [item]);

  if (!item) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 p-4"
    >
      {/* MODAL BOX */}
      <motion.div
        layoutId={`card-${item.id}`}
        className="relative bg-white rounded-xl max-w-3xl w-full p-4 overflow-auto"
      >
        {/* CLOSE BUTTON */}
        <button
          onClick={close}
          className="absolute top-3 right-3 bg-gray-100 hover:bg-gray-200 text-xl p-2 rounded-full"
        >
          ✕
        </button>

        <div className="md:flex gap-6">
          {/* IMAGE */}
          <img
            src={item.image}
            alt={item.name}
            className="md:w-1/2 w-full h-80 object-cover rounded-lg"
          />

          {/* RIGHT SECTION */}
          <div className="md:w-1/2 mt-4 md:mt-0">
            <h2 className="text-2xl font-bold">{item.name}</h2>

            {/* PRICE */}
            <div className="mt-3 flex items-center gap-3">
              <div className="text-2xl font-bold">₹{item.discountedPrice}</div>
              <div className="text-sm text-gray-400 line-through">₹{item.price}</div>
              <div className="text-xs bg-indigo-600 text-white px-2 py-1 rounded">
                -{item.discountPercent}%
              </div>
            </div>

            {/* DETAILS */}
            <div className="mt-4 text-gray-700 space-y-2">
              <p>
                <strong>Material:</strong> {item.material}
              </p>
              <p>
                <strong>Weight:</strong> {item.weight}
              </p>
              <p>
                <strong>Size:</strong> {item.size}
              </p>
              <p>
                <strong>Chain Length:</strong> {item.length}
              </p>
              <p>
                <strong>Manufacturing:</strong> {item.manufacturing}
              </p>
            </div>

            {/* BUTTONS */}
            <div className="mt-5 flex gap-3">
              <button className="px-4 py-2 bg-green-600 text-white font-semibold rounded-md w-1/2">
                Buy Now
              </button>
              <button
                onClick={() => {
                  addToCart(item);
                  toast.success("Added to Cart 🛒");
                }}
                className="px-4 py-2 border font-semibold rounded-md w-1/2"
              >
                Add to Cart
              </button>
            </div>
          </div>
        </div>

        {/* 2×2 INFO GRID */}
        <div className="mt-6 grid grid-cols-2 gap-3">
          <div className="bg-black text-white p-3 rounded-xl text-sm flex flex-col">
            <span className="text-lg">🔄</span>
            Return / Exchange: {item.returnPolicy}
          </div>

          <div className="bg-gray-200 p-3 rounded-xl text-sm flex flex-col">
            <span className="text-lg">💎</span>
            Purity: {item.secSilverPercent}
          </div>

          <div className="bg-gray-200 p-3 rounded-xl text-sm flex flex-col">
            <span className="text-lg">🛡️</span>
            Warranty: {item.warranty}
          </div>

          <div className="bg-black text-white p-3 rounded-xl text-sm flex flex-col">
            <span className="text-lg">📦</span>
            Shipping: {item.shipping}
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}
